export const loadingFillColor = '#ff6600'
export const loadingTrackColor = '#ffbb96'

export const transactionFee = 5; 